export class BackupZeroEtlMultiResourceRoutingPolicy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "routingMode",
            "baseName": "routingMode",
            "type": "BackupZeroEtlRoutingMode",
            "format": ""
        },
        {
            "name": "namespaceTemplate",
            "baseName": "namespaceTemplate",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableTemplate",
            "baseName": "tableTemplate",
            "type": "string",
            "format": ""
        },
        {
            "name": "identityColumns",
            "baseName": "identityColumns",
            "type": "Array<BackupZeroEtlIdentityColumnSpec>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlMultiResourceRoutingPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
